import { IcChevronBackNegative, IcChevronRightBold } from '@assets/icons/24x24';
import { Box, Center, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import NotificationProcedure from '@components/cockpit/panels/notification/detail/procedure/NotificationProcedure';
import StatusBar from '@components/common/StatusBar';
import { CSSProperties, useState } from 'react';
import { useIntl } from 'react-intl';
import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList } from 'react-window';

import { Procedure } from '@/types/config/procedure.types';

type Props = {
  procedures: Procedure[];
};

export function SearchNotificationProcedureDetails({ procedures }: Readonly<Props>) {
  const { formatMessage } = useIntl();
  const [selectedProcedure, setSelectedProcedure] = useState<Procedure | null>(null);

  const Row = ({ index, style }: { index: number; style: CSSProperties }) => {
    const procedure = procedures[index];
    return (
      <HStack
        className="group"
        width="100%"
        style={style}
        backgroundColor="neutral.700"
        borderBottom={index === procedures.length ? 'none' : '2px solid'}
        borderColor="neutral.900"
        gap={0}
        key={procedure.id}
        flex={1}
        cursor="pointer"
        onClick={() => setSelectedProcedure(procedure)}
      >
        <HStack boxSize="100%" paddingX={4}>
          <StatusBar activated />
          <HStack justifyContent="space-between" width="100%">
            <Text marginLeft={3}>{procedure.name}</Text>
            <Text backgroundColor="neutral.black" paddingX={0.5} color="green.500" lineHeight="18px">
              {formatMessage({ id: `notification.procedure.state.${procedure.state}` })}
            </Text>
          </HStack>
        </HStack>
        <Box height="100%" width="2px" bg="neutral.900" />
        <Center width="56px">
          <Icon boxSize="24px" as={IcChevronRightBold} color="neutral.300" _groupHover={{ color: 'skyBlue' }} />
        </Center>
      </HStack>
    );
  };

  return selectedProcedure ? (
    <VStack gap={0.25} height="100%" backgroundColor="neutral.900" alignItems="start">
      <HStack height="56px" className="group" cursor="pointer" onClick={() => setSelectedProcedure(null)}>
        <Icon
          boxSize="24px"
          marginX={2}
          as={IcChevronBackNegative}
          color="neutral.300"
          _groupHover={{ color: 'skyBlue' }}
        />
        <Text color="neutral.200" _groupHover={{ color: 'skyBlue' }}>
          {formatMessage({ id: 'global.back' })}
        </Text>
      </HStack>
      <NotificationProcedure currentStepRank={null} procedure={selectedProcedure} />
    </VStack>
  ) : (
    <AutoSizer style={{ width: '100%', height: '100%' }} disableWidth>
      {({ height }) => (
        <FixedSizeList
          className="cockpit-scrollbar no-margin"
          height={height}
          width="100%"
          itemCount={procedures.length}
          itemSize={82}
        >
          {Row}
        </FixedSizeList>
      )}
    </AutoSizer>
  );
}
